import React, { FC, useState, useEffect } from 'react';
import { ProductSize } from '../types/types';
import { Table } from './Table';
import { Icon } from './Icon';
import {useHistory} from "react-router-dom";

// import ShirtGuide from '../assets/img/shirt-guide.png';

interface SizeGuidePopUpProps {
  open: boolean;
  onClose: () => void;
  productSizes: ProductSize[];
  schemeImageUrl?: string;
}

interface ProductSizeRows {
  [key: string]: Record<string, string>
}

export const SizeGuidePopUp: FC<SizeGuidePopUpProps> = ({
  onClose,
  open,
  productSizes,
  schemeImageUrl,
}) => {
  // 사이즈명 중복 제거하여 추출
  // ex) ['S', 'M', 'L', 'XL']
  const sizeNames: string[] = Array.from(
    new Set(productSizes.map((productSize) => productSize.sizeName))
  );
  const tableHeadLength = sizeNames.length + 1;
  const [productSizeRows, setProductSizeRows] = useState<ProductSizeRows>({});
  const {push} = useHistory();

  useEffect(() => {
    /*
    productSizes를 테이블 렌더링 가능한 구조로 변경하여 productSizeRows에 저장

    ex)
    productSizeRows = {
      '가로': {
        s: '51',
        m: '55',
        l: '59.5',
        xl: '62.5',
      },
      '소매길이': {
        s: '51',
        m: '52',
        l: '53',
        xl: '-',
      }
    };
     */
    productSizes.forEach((productSize) => {
      Object.keys(productSize.actualMeasures ?? []).forEach((measureKey) => {
        if (!productSizeRows[measureKey]) {
          productSizeRows[measureKey] = {};
          sizeNames.forEach((sizeName) => {
            productSizeRows[measureKey][sizeName] = '-';
          });
        }

        productSizeRows[measureKey][productSize.sizeName] =
          productSize.actualMeasures![measureKey];
      });
    });

    setProductSizeRows(productSizeRows);
  }, [productSizes]);

  if (!open) return <></>;
  return (
    <>
      <div className="fixed inset-0 z_1000 flex items-center justify-center md:px-4">
        <div className="bg-white z_1000 xl:block hidden h_90 relative z-100 rounded-lg">
          <div className="relative pl-5 pb-3 pt-3 border-b mb-5 bg-white rounded-t-lg">
            <p className="font-medium text-12 text-left">
              사이즈 가이드
              <span className="block font-normal text-gray-400 mt-3">
              저희는 최대한 고객님에게 가장 자신에게 알맞는 사이즈를 선택할 수 있도록 모든 제품을 직접 측정 합니다.
                </span>
            </p>
            <button onClick={onClose} className="absolute -right-3 -top-3 bg-gray-800 rounded-full p-1 hover:opacity-80">
              <Icon.X className="wh-4 stroke_white" />
            </button>
          </div>
          <div className="mx-5 flex">
            <div className="max_width_s float-left -mt-14 mr-5 mb-5">
              {schemeImageUrl && (
                  <img
                      src={schemeImageUrl}
                      alt="실측 이미지"
                      className=""
                  />
              )}
            </div>
            <div className={`flex flex-col`}>
              <Table className="border my-5">
                <Table.Head>
                  <Table.Row className="border-b">
                    <Table.Th className="text-12 py-5 bg-white">단위(cm)</Table.Th>
                    {sizeNames.map((sizeName, index) => (
                        <Table.Th key={index} className="text-12 py-5 bg-white border-l text-center min_width60">{sizeName}</Table.Th>
                    ))}
                  </Table.Row>
                </Table.Head>
                <Table.Body>
                  {Object.keys(productSizeRows).filter(
                      it => it !== ""
                  ).map(
                      (productSizeRowKey, index) => {
                        const productSizeRow = productSizeRows[productSizeRowKey];
                        return (
                            <Table.Row key={index}>
                              <Table.Td className="text-12 py-5">{productSizeRowKey}</Table.Td>
                              {sizeNames.map((sizeName, index) => (
                                  <Table.Td key={index} className="text-12 py-5 border-l text-center min_width">
                                    {productSizeRow[sizeName]}
                                  </Table.Td>
                              ))}
                            </Table.Row>
                        );
                      },
                  )}
                </Table.Body>
              </Table>
              <div className="w-fit text-12 text-12 font-medium">
                <div className="text-12 pb-4 font-normal">
                  측정 방법에 따라 1~2cm의 오차가 있을 수 있는 점 참고 부탁드립니다.<br/>
                  <span className="text-gray-400">보유하고 계신 동일한 카테고리의 의류를 위 도식화와 동일한 방식으로 측정 후<br/>비교하시면 구매에 많은 도움이 됩니다.</span>
                </div>
                <div className="pb-5">
                  문의사항<br/>
                  <span className="text-12 text-gray-400 font-normal">
                    상품 및 구매 관련 안내사항은 <span className="text-gray-500">(<span className="underline"><button onClick={() => push(`/cc/contact-us`)}>문의하기</button></span>)</span> 또는 고객센터<span className="text-gray-500">(<a href="tel:025410854">02-541-0854</a>)</span> 로 문의주시면<br/>보다 자세한 안내를 받으실 수 있습니다.
              </span>
                </div>
                <div className="pb-5">
                  교환 및 환불<br/>
                  <span className="text-12 text-gray-400 font-normal">
                    상품 수령(배송 완료) 후 7일 이 내에 교환 및 신청이 가능합니다.<br/>자세한 내용은 <span className="text-gray-500">(<span className="underline"><button onClick={() => push(`/cc/custom/4`)}>교환 및 환불 안내</button></span>)</span> 를 통하여 확인이 가능합니다.
              </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div onClick={onClose} className="bg-black bg-opacity-70 absolute w-full h-full z-1"></div>
        {/*mobile view*/}
        <div className="xl:hidden block bg-white w-full h-full overflow-scroll relative z-50 element2">
          <div className="bg-white relative z-100 mb-20">
            <div className="relative pl-4 pb-3 pt-3 border-b relative z-10">
              <p className="font-medium text-12 text-left">
                사이즈 가이드
                <span className="block font-normal text-gray-400 mt-3">
                   저희는 최대한 고객님에게 가장 자신에게 알맞는 사이즈를<br/>선택할 수 있도록 모든 제품을 직접 측정 합니다.
                  </span>
              </p>
              <button onClick={onClose} className="absolute right-3 top-2 bg-gray-800 rounded-full p-1 hover:opacity-80">
                <Icon.X className="wh-4 stroke_white" />
              </button>
            </div>
            <div className="max-w-3xl m-auto relative z-10">
              {schemeImageUrl && (
                  <img
                      src={schemeImageUrl}
                      alt="실측 이미지"
                      className=""
                  />
              )}
            </div>
            <Table className="border m-auto relative z-10">
              <Table.Head>
                <Table.Row>
                  <Table.Th className="text-12 py-2">단위(cm)</Table.Th>
                  {sizeNames.map((sizeName, index) => (
                      <Table.Th key={index} className="text-12 py-2 border-l text-center w-16">{sizeName}</Table.Th>
                  ))}
                </Table.Row>
              </Table.Head>
              <Table.Body>
                {Object.keys(productSizeRows).filter(
                    it => it !== ""
                ).map(
                    (productSizeRowKey, index) => {
                      const productSizeRow = productSizeRows[productSizeRowKey];

                      return (
                          <Table.Row key={index}>
                            <Table.Td className="text-12 py-2">{productSizeRowKey}</Table.Td>
                            {sizeNames.map((sizeName, index) => (
                                <Table.Td key={index} className="text-12 py-2 border-l text-center w-16">
                                  {productSizeRow[sizeName]}
                                </Table.Td>
                            ))}
                          </Table.Row>
                      );
                    },
                )}
                {/*<Table.Row>*/}
                {/*  <Table.Td colSpan={tableHeadLength} className="text-center">*/}
                {/*    * 측정 방법에 따라 1~2cm의 오차가 있을 수 있습니다.*/}
                {/*  </Table.Td>*/}
                {/*</Table.Row>*/}
              </Table.Body>
            </Table>
            <div className="pt-5 m-auto px-4 text-12 pb-7 max-w-xl relative z-10">
              측정 방법에 따라 1~2cm의 오차가 있을 수 있는 점 참고 부탁드립니다.
              <span className="text-gray-400 mt-2 block">보유하고 계신 동일한 카테고리의 의류를 위 도식화와 동일한 방식으로<br/>측정 후 비교하시면 구매에 많은 도움이 됩니다.</span>
            </div>
            <div className="pb-5 max-w-xl m-auto pl-4 pr-3 text-12 relative z-10">
              문의사항<br/>
              <span className="text-12 text-gray-400 font-normal">
                  상품 및 구매 관련 안내사항은 <span className="text-gray-500">(<span className="underline"><button onClick={() => push(`/cc/contact-us`)}>문의하기</button></span>)</span>
                  또는 고객센터<span className="text-gray-500">(<span><a href="tel:025410854">02-541-0854</a></span>)</span>로 문의주시면 보다 자세한 안내를 받으실 수 있습니다.
                </span>
            </div>
            <div className="pb-5 max-w-xl m-auto px-4 text-12 relative z-10">
              교환 및 환불<br/>
              <span className="text-12 text-gray-400 font-normal">
                    상품 수령(배송 완료) 후 7일 이 내에 교환 및 신청이 가능합니다.
                  자세한 내용은 <span className="text-gray-500">(<span className="underline"><button onClick={() => push(`/cc/custom/4`)}>교환 및 환불 안내</button></span>)</span> 를 통하여 확인이 가능합니다.
                </span>
            </div>
            <div className="h-10"></div>
          </div>
          <button onClick={onClose} className="element2 w-full py-6 text-center fixed bg-black text-white text-12 bottom-0 z_1000">닫기</button>
        </div>
      </div>
    </>
  );
};
